export default __webpack_public_path__ + "static/media/header-pancake.5b332ae6.svg";